// src/routes/PageDetails.jsx
import { useParams } from "react-router-dom";

import PageRenderer from "./PageRender";
import MenuService from "../../services/MenuService";
import { useQuery } from "@tanstack/react-query";
import Cover404 from "../../common/Cover404";

const PageDetails = () => {
  const { slug } = useParams();


  const { isLoading, error, data } = useQuery({
    queryKey: ["menu-list"],
    queryFn: MenuService.getList,
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading page</div>;

  // ✅ FIND PAGE BY SLUG
  const page = data?.find((item) => item.slug === slug);

  if (!page) return <Cover404 />;

  return <PageRenderer pageData={page} />;
};

export default PageDetails;